import React from "react";
import styled from "@emotion/styled";
import { withTheme } from "@emotion/react";
import { Line } from "react-chartjs-2";
import { MoreVertical } from "react-feather";

import {
  Card as MuiCard,
  CardContent,
  CardHeader,
  IconButton,
} from "@mui/material";
import { spacing } from "@mui/system";

const Card = styled(MuiCard)(spacing);

const ChartWrapper = styled.div`
  height: 378px;
`;

function LineChart({ theme, reports = [], labelFormatter }) {
  const fmtLabel =
    typeof labelFormatter === "function"
      ? labelFormatter
      : (d) => String(d ?? "");

  const labels = reports.map((r) => fmtLabel(r?.date));

  const locations = Array.from(
    new Set(
      reports
        .flatMap((r) =>
          Array.isArray(r?.locationStats) ? r.locationStats : []
        )
        .map((s) => s?.location)
        .filter(Boolean)
    )
  );

  // Theme-backed palette (falls back to cycling if more locations)
  const palette = [
    theme.palette.success.main,
    theme.palette.primary.main,
    theme.palette.secondary.main,
    theme.palette.info.main,
    theme.palette.warning.main,
  ];

  const datasets = locations.map((loc, i) => {
    const base = palette[i % palette.length];
    return {
      label: String(loc),
      fill: false,
      backgroundColor: "transparent",
      borderColor: base,
      tension: 0.35,
      pointRadius: 2,
      pointHoverRadius: 4,
      data: reports.map((r) => {
        const stats = Array.isArray(r?.locationStats) ? r.locationStats : [];
        const found = stats.find((s) => String(s?.location) === String(loc));
        return Number(found?.totalItems) || 0;
      }),
    };
  });

  const data = {
    labels,
    datasets,
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
      },
    },
    scales: {
      x: {
        grid: {
          color: "rgba(0,0,0,0.0)",
        },
      },
      y: {
        grid: {
          color: "rgba(0,0,0,0.0375)",
          fontColor: "#fff",
        },
      },
    },
  };

  return (
    <Card mb={6}>
      <CardHeader
        action={
          <IconButton aria-label="settings" size="large">
            <MoreVertical />
          </IconButton>
        }
        title="Items tested by location (last 30 reports)"
      />
      <CardContent>
        <ChartWrapper>
          <Line data={data} options={options} />
        </ChartWrapper>
      </CardContent>
    </Card>
  );
}
export default withTheme(LineChart);
